import PropTypes from 'prop-types'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import Textarea from 'components/Textarea'
import TextInput from 'components/TextInput'
import LabelledField from 'components/LabelledField'
import RadioInputs from 'components/RadioInputs'

import FormSection from 'pages/shared/FormSection'

import { color } from 'styles/colors'

import { scrubText } from 'helpers/inputCleaners'
import { DropzoneArea } from 'mui-file-dropzone'

const propTypes = {
  imageType: PropTypes.string.isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  image: PropTypes.string,
  errors: PropTypes.shape(PropTypes.shape)
}

const defaultProps = {
  title: '',
  message: '',
  image: '',
  errors: {}
}

const MessageFields = ({ imageType, image, title, message, onChangeCallback, errors }) => {
  const onFileChange = (files) => {
    const file = files[0]
    const reader = new FileReader()

    reader.onload = () => {
      onChangeCallback({ image: reader.result })
    }

    reader.readAsDataURL(file)
  }

  return (
    <FormSection title="Image">
      <LabelledField label="Image Type" id="image-type">
        <RadioInputs
          selectedValue={imageType}
          radioOptions={[
            { label: 'Image', value: 'image' },
            { label: 'Icon', value: 'icon' }
          ]}
          onChange={(event) => onChangeCallback({ imageType: event.target.value })}
        />
      </LabelledField>

      {
        !image &&
        <DropzoneArea
          acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', 'image/gif']}
          filesLimit={1}
          dropzoneText={'Drag and drop an image (jpeg, jpg, png, bmp, gif) here or click'}
          onDrop={files => onFileChange(files)}
        />
      }

      {
        image &&
        <S.RemoveImage>
          <NavLink to="#" onClick={() => onChangeCallback({ image: null })}>Remove image</NavLink>
          <S.Image id="image" alt="select" src={image} {...{ imageType }} />
        </S.RemoveImage>
      }

      <TextInput
        label="Title"
        isRequired
        onChange={event => onChangeCallback({ title: scrubText(event.target.value, true) })}
        value={title || ''}
        errorMessage={errors.title}
      />

      <Textarea
        label="Message"
        isRequired
        rows="10"
        onChange={event => onChangeCallback({ message: scrubText(event.target.value, true) })}
        value={message || ''}
        errorMessage={errors.message}
      />
    </FormSection>
  )
}

MessageFields.propTypes = propTypes
MessageFields.defaultProps = defaultProps

export default MessageFields

const S = {
  RemoveImage: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 750px;
  `,
  Image: styled.img.withConfig({
    shouldForwardProp: (prop) => !['imageType'].includes(prop)
  })`
    border: 1px solid ${color('border')};
    ${({ imageType }) => imageType === 'icon' ? 'width: 64px;' : 'width: max-content;'}
  `,
  RadioInputLabels: `
    border-radius: 4px;
    border: 1px solid;
    border-color: ${color('border')};
    text-align: center;
    padding: 0px 10px;
    font-weight: 900;
    font-size: 12px;
    text-transform: uppercase;
  `
}
